<template>
    <vx-card class='vx-col w-full mt-4'>
        <!--MENU EVALUACIONES-->
        <div class="flex">
            <button class="mr-3 boton tipoMenu0 activeBtn" @click="tipoMenu=0;menu=0;estadoMenu();"><i class="fa-regular fa-folder-open"></i> Desafíos</button>
            <button class="mr-3 boton tipoMenu1" @click="tipoMenu=1;menu=2;estadoMenu();"><i class="fa-solid fa-clipboard-question"></i> Mis desafíos</button>
        </div>
        <vs-divider></vs-divider>
       <!--LISTADO DE EVALUACIONES-->
        <div v-if="menu == 0">
            <!-- <h2 class="text-lg">Mis Evaluaciones</h2> -->
            <vs-button icon="add" class="vs-button mt-5 p-3" @click="id=0;ObjectSelected='';menu = 1;">Crear desafío</vs-button>
            <Eval_lista_docente :arrayEvaluaciones="arrayEvaluaciones" @changeHandle="changeHandle"/>
        </div>
        <!--CREAR EVALUACIONES-->
        <div v-if="menu == 1">
            <h3 class="mt-1">{{ id == 0 ? 'Crear' :'Editar'}} desafío:</h3>
            <!-- <vs-button color="#f5f5f5" style="color:#1872DF;" class="vs-button mt-3 p-2" @click="menu = 0;getEvaluaciones();">← Volver</vs-button> -->
            <Eval_crear_docente  :id="id" :ObjectSelected="ObjectSelected" @changeHandle="changeHandle"/>
        </div>
        <!--MIS PREGUNTAS-->
        <div v-if="menu == 2">
            <ScreenMisPreguntasVue/>
        </div>
        <!--EVALUACIONES RESPONDIDAS-->
        <div v-if="menu == 3">
            <ScreenRevisionEvaluacionVue :ObjectSelected="ObjectSelected" @changeHandle="changeHandle"/>
        </div>
    </vx-card>
</template>
<script>
const Eval_crear_docente            = () => import('./evaluaciones/eval_crear_docente.vue');
const ScreenMisPreguntasVue         = () => import('./evaluaciones/components/MisPreguntas/ScreenMisPreguntas.vue')
const ScreenRevisionEvaluacionVue   = () => import('./evaluaciones/EvaluacionesRevision/ScreenRevisionEvaluacion.vue');
import Eval_lista_docente from './evaluaciones/lista_evaluaciones_docente.vue';
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default {
    mixins: [GeneralMixin],
    components: {
        Eval_crear_docente,
        Eval_lista_docente,
        ScreenMisPreguntasVue,
        ScreenRevisionEvaluacionVue,
    },
    data() {
        return {
            usuario:[],
            menu:0,
            id:0,
            arrayEvaluaciones:[],
            ObjectSelected:'',
            tipoMenu:0,
        };
    },
    created() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted() {
        this.getEvaluaciones();
        this.estadoMenu();
    },
    methods: {
        changeHandle(e, data){
            let me                  = this;
            me.menu                 = e;
            //crear / editar evaluacion
            // if(e == 0) {}
            if(e == 1){
                this.id             = data.id;
                this.ObjectSelected = data;
                this.getEvaluaciones()
            }
            //ver calificaciones evaluaciones
            if(e == 3){
                this.menu           = 3;
                this.ObjectSelected = data;
            }
        },
        getEvaluaciones(){
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url+`evaluacion?getEvaluaciones=1&idperiodo=${ localStorage.periodo_id }&idusuario=${ me.usuario.idusuario }`)
                .then(function (response) {
                    console.log('response',response.data)
                    me.arrayEvaluaciones = response.data;
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.$vs.loading.close();
                    me.f_notificaciones("No se pudo cargar las evaluaciones", "danger");
                })
        },
        estadoMenu(){
            let me = this;
            localStorage.setItem('menuDocenteEvaluaciones',me.tipoMenu)
            var divs = document.querySelectorAll(".boton");
            for (var i = 0; i < divs.length; i++) {
                divs[i].classList.remove("activeBtn");
            }
            const container = document.querySelector(".tipoMenu"+me.tipoMenu);
            container.classList.add("activeBtn");
        },
    }
};
</script>
<style scoped>
.boton{
    background-color: #f6f6f6;
    color: #2F68AD;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    border: #cac4c4 2px solid;
    transition: 1s ease-out;
}
.boton:hover{
    background-color: #2F68AD;
    color: white;
}
/*MENU*/
.activeBtn{
    background-color: #2F68AD;
    color: white;
}
</style>
